import PropTypes from 'prop-types';
import { FiPlus, FiStar } from 'react-icons/fi';

import { ButtonText, Spinner, StyledButton } from './styles';

const propTypes = {
  text: PropTypes.string.isRequired,
  primary: PropTypes.bool,
  textBold: PropTypes.bool,
  onClick: PropTypes.func,
  withIcon: PropTypes.oneOf(['star', 'plus']),
  color: PropTypes.string,
  type: PropTypes.string,
  minWidth: PropTypes.number,
  isDisabled: PropTypes.bool,
  title: PropTypes.string,
  isLoading: PropTypes.bool,
  loadingText: PropTypes.string,
};

const defaultProps = {
  textBold: false,
  primary: false,
  withIcon: null,
  color: null,
  type: 'button',
  minWidth: 0,
  isDisabled: false,
  isLoading: false,
  loadingText: null,
};

const Button = ({
  text,
  primary,
  onClick,
  textBold,
  withIcon,
  color,
  type,
  minWidth,
  isDisabled,
  title,
  isLoading,
  loadingText,
}) => {
  function renderButtonIcon() {
    const iconColor = primary ? '#fff' : 'currentColor';

    switch (withIcon) {
      case 'star':
        return <FiStar size={18} color={iconColor} fill={iconColor} />;
      case 'plus':
        return <FiPlus size={18} color={iconColor} />;
      default:
        return <></>;
    }
  }

  return (
    <StyledButton
      type={type}
      primary={primary}
      color={color}
      onClick={onClick}
      minWidth={minWidth}
      disabled={isDisabled || isLoading}
      data-loading={isLoading}
      title={title}
    >
      {isLoading && <Spinner aria-hidden />}
      <ButtonText
        primary={primary}
        bold={textBold}
        withIcon={withIcon}
        color={color}
      >
        {isLoading ? loadingText || text : text}
      </ButtonText>
      {/* Durante o carregamento o spinner ocupa o lugar do ícone. */}
      {!isLoading && withIcon && renderButtonIcon()}
    </StyledButton>
  );
};

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;

export default Button;
